(function () {
  "use strict";

  var ROTATE_MS = 5000;
  var TRANSITION_MS = 500;

  document.querySelectorAll("[data-announcement-bar]").forEach(function (bar) {
    var items = bar.querySelectorAll(".announcement-bar__message");
    if (!items.length) return;

    items[0].classList.add("is-active");
    if (items.length < 2) return;

    var index = 0;

    setInterval(function () {
      var current = items[index];
      var nextIndex = (index + 1) % items.length;
      var next = items[nextIndex];

      current.classList.remove("is-active");
      current.classList.add("is-leaving");
      next.classList.add("is-active");

      setTimeout(function () {
        current.classList.remove("is-leaving");
      }, TRANSITION_MS);

      index = nextIndex;
    }, ROTATE_MS);
  });
})();